module.exports = __webpack_public_path__ + "media/images/CFP_logo-26f64aff47e350d0c8d9388beb0fa97d.png";